import { render, staticRenderFns } from "./TemperatureChart.vue?vue&type=template&id=3b71096e&scoped=true"
import script from "./TemperatureChart.vue?vue&type=script&lang=js"
export * from "./TemperatureChart.vue?vue&type=script&lang=js"
import style0 from "./TemperatureChart.vue?vue&type=style&index=0&id=3b71096e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71096e",
  null
  
)

export default component.exports